import { render, staticRenderFns } from "./PreLoader.vue?vue&type=template&id=020570cd&scoped=true&"
import script from "./PreLoader.vue?vue&type=script&lang=ts&"
export * from "./PreLoader.vue?vue&type=script&lang=ts&"
import style0 from "./PreLoader.vue?vue&type=style&index=0&id=020570cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020570cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
